import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { Footer } from 'src/shared';
import { ReactComponent as CTIcon } from 'src/assets/icons/ct.svg';

const CTContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #0f0f0f 0%, #1a1a1a 25%, #2d2d2d 50%, #1a1a1a 75%, #0f0f0f 100%);
  color: #ffffff;
  display: flex;
  flex-direction: column;
`;

const Header = styled.header`
  padding: 20px 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(15, 15, 15, 0.95);
  backdrop-filter: blur(10px);
  border-bottom: 2px solid #404040;
`;

const BackButton = styled.button`
  background: rgba(255, 255, 255, 0.1);
  border: 2px solid #606060;
  color: #ffffff;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background: rgba(255, 255, 255, 0.2);
    border-color: #808080;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
  }
`;

const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: 800;
  text-align: center;
  margin: 0;
  color: #ffffff;
  text-shadow: 0 4px 8px rgba(0, 0, 0, 0.8);
`;

const Content = styled.div`
  flex: 1;
  padding: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const CTCard = styled.div`
  background: rgba(255, 255, 255, 0.05);
  border-radius: 20px;
  backdrop-filter: blur(10px);
  border: 2px solid #404040;
  padding: 4vh 3vw;
  max-width: 80vw;
  min-width: 300px;
  text-align: center;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  
  @media (max-width: 768px) {
    padding: 30px;
    max-width: 95vw;
  }
  
  @media (min-width: 1200px) {
    padding: 50px;
    max-width: 800px;
  }
`;

const CTIconContainer = styled.div`
  width: 8vw;
  height: 8vw;
  min-width: 60px;
  min-height: 60px;
  max-width: 120px;
  max-height: 120px;
  margin-bottom: 2vh;
  display: flex;
  align-items: center;
  justify-content: center;
  
  svg {
    width: 100%;
    height: 100%;
    filter: brightness(1.2) contrast(1.1);
  }
`;

const CTTitle = styled.h2`
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 20px;
  color: #ffffff;
`;

const CTDescription = styled.p`
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 30px;
  opacity: 0.9;
`;

const FeatureList = styled.ul`
  text-align: left;
  font-size: 1rem;
  line-height: 1.8;
  opacity: 0.9;
`;

const CT: React.FC = () => {
  const navigate = useNavigate();

  return (
    <CTContainer>
      <Header>
        <BackButton onClick={() => navigate('/medical_imaging')}>
          ← Back to Medical Imaging
        </BackButton>
        <Title>CT Imaging</Title>
        <div style={{ width: '120px' }}></div>
      </Header>

      <Content>
        <CTCard>
          <CTIconContainer>
            <CTIcon />
          </CTIconContainer>
          <CTTitle>Computed Tomography</CTTitle>
          <CTDescription>
            Advanced cross-sectional imaging technology providing detailed internal 
            body structure visualization with high-resolution 3D reconstruction capabilities.
          </CTDescription>
          
          <FeatureList>
            <li><strong>Cross-sectional Imaging:</strong> Detailed internal structure views</li>
            <li><strong>3D Reconstruction:</strong> Volumetric data visualization</li>
            <li><strong>Multi-planar Views:</strong> Axial, sagittal, and coronal imaging</li>
            <li><strong>Contrast Enhancement:</strong> Vascular and tissue differentiation</li>
            <li><strong>High Resolution:</strong> Sub-millimeter precision imaging</li>
            <li><strong>AI Analysis:</strong> Automated abnormality detection</li>
          </FeatureList>
        </CTCard>
      </Content>

      <Footer />
    </CTContainer>
  );
};

export default CT;
